<template>
  <div class="d-flex align-center justify-center">
    <div class="heading-4 font-weight-medium">{{ txType }}</div>
    <v-divider class="mx-6 border-stake" vertical></v-divider>
    <div
      class="text-7 font-weight-medium px-2 py-1 rounded-5 black--text-abs bg-stake"
    >
      PROOF-OF-STAKE
    </div>
    <v-divider class="mx-6 border-stake" vertical></v-divider>
    <img
      :src="selectedEcosystem.logo"
      alt="tendermint"
      height="20"
      width="20"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ECOSYSTEMS from "@/common/config/ecosystems";

export default {
  props: {
    txType: String,
  },
  computed: {
    ...mapGetters({
      currentProject: "projectConfig/latestProject",
    }),
    selectedEcosystem() {
      return ECOSYSTEMS.find(
        item =>
          item.name.toLowerCase() ===
          this.currentProject.ecosystem.toLowerCase()
      );
    },
  },
};
</script>
